export enum CurrencyEnum {
  URUGUAYAN_PESOS = 1,
  US_DOLLAR,
}
